import { KuxEpisodeType } from '@kaltura-ott/tvpil';

import { VodAsset } from './VodAsset';

export class Episode extends VodAsset<KuxEpisodeType> {
  constructor(data: KuxEpisodeType) {
    super(data);
  }

  get mediaFileId(): number | undefined {
    return this.data.mediaFileId;
  }

  get seriesId(): string | undefined {
    return this.data.seriesId;
  }

  get isGroupedSeries(): boolean {
    return this.data.isGroupedSeries;
  }
}
